<template>
  <div class="home-page">
    <!-- 1. Hero Section -->
    <section class="hero-section" ref="hero">
      <div class="hero-bg"></div>
      <div class="container hero-content">
        <span class="hero-subtitle">✨ 당신의 일상에 마법을! ✨</span>
        <h1>
          매일매일 상쾌한 공간,<br />
          아스톡 에어졸이 선사합니다
        </h1>
        <p>
          단 한 번의 분사로 놀라운 변화! 유해해충은 사라지고, 깨끗함만 남는
          특별한 경험을 지금 바로 시작하세요!
        </p>
        <div class="hero-buttons">
          <a href="#product" class="btn btn-primary">제품 둘러보기</a>
          <a href="#cta" class="btn btn-secondary">상담 신청</a>
        </div>
      </div>
      <a href="#features" class="scroll-indicator">
        <span>Scroll</span>
        <div class="arrow-down"></div>
      </a>
    </section>

    <!-- 2. Key Features Section -->
    <section id="features" class="features-section animated-section">
      <div class="container">
        <div class="feature-item">
          <div class="value">99.9%</div>
          <div class="label">살충 효과</div>
        </div>
        <div class="feature-item">
          <div class="value">10초</div>
          <div class="label">즉각 효과</div>
        </div>
        <div class="feature-item">
          <div class="value">99.9%</div>
          <div class="label">안전 성분</div>
        </div>
        <div class="feature-item">
          <div class="value">24시간</div>
          <div class="label">지속 효과</div>
        </div>
      </div>
    </section>

    <!-- 3. Core Values Section -->
    <section class="values-section bg-light animated-section">
      <div class="container">
        <SectionHeader
          subtitle="ASTOC만의 특별함"
          title="아스톡 에어졸, 왜 선택해야 할까요?"
        />
        <p class="section-description">
          단순한 방역을 넘어, 당신의 삶을 더 빛나게 할 아스톡의 놀라운 가치를
          만나보세요!
        </p>
        <div class="values-grid">
          <div class="value-card">
            <div class="icon">⚡</div>
            <h3>번개처럼 빠른 효과!</h3>
            <p>
              칙- 뿌리는 순간, 유해해충과 해충은 안녕! 당신의 공간을 순식간에
              청정 구역으로 바꿔드립니다.
            </p>
          </div>
          <div class="value-card">
            <div class="icon">🛡️</div>
            <h3>온 가족 안심 성분!</h3>
            <p>
              사랑하는 아이와 반려동물도 걱정 없이! 자연 유래 성분으로 안전하게,
              마음 편히 사용하세요.
            </p>
          </div>
          <div class="value-card">
            <div class="icon">🌱</div>
            <h3>지구까지 생각하는 착한 마음!</h3>
            <p>
              환경을 위한 지속 가능한 포장과 성분으로, 깨끗한 지구를 함께
              만들어갑니다.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- 4. Gallery Section -->
    <section id="gallery" class="gallery-section bg-light">
      <div class="container">
        <SectionHeader subtitle="Gallery" title="제품 갤러리" />
        <div class="gallery-grid">
          <div class="gallery-item">
            <img
              :src="require('@/assets/images/2-DOKVQmAK.jpg')"
              alt="제품 이미지 1"
            />
          </div>
          <div class="gallery-item">
            <img
              :src="require('@/assets/images/2-DOKVQmAK.jpg')"
              alt="제품 이미지 2"
            />
          </div>
          <div class="gallery-item">
            <img
              :src="require('@/assets/images/3-DE4RbGuR.jpg')"
              alt="제품 이미지 3"
            />
          </div>
          <div class="gallery-item">
            <img
              :src="require('@/assets/images/4-CNzeZswI.jpg')"
              alt="제품 이미지 4"
            />
          </div>
          <div class="gallery-item">
            <img
              :src="require('@/assets/images/5-CyyYTxGg.jpg')"
              alt="제품 이미지 5"
            />
          </div>
          <div class="gallery-item">
            <img
              :src="require('@/assets/images/3-DE4RbGuR.jpg')"
              alt="제품 이미지 6"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- 5. Best Seller Section -->
    <section id="product" class="product-section animated-section">
      <div class="container product-grid">
        <div class="product-image">
          <img
            :src="require('@/assets/images/3-DE4RbGuR.jpg')"
            alt="아스톡 에어졸 제품"
          />
        </div>
        <div class="product-info">
          <div class="product-story">
            <div class="story-part">
              <h4 class="part-title">최상의 가치</h4>
              <span class="section-subtitle"
                >👑 이미 수많은 고객이 경험한 기적, 당신의 차례입니다! 👑</span
              >
              <h2>
                세상의 모든 공간을 위한 단 하나의 마스터피스, 아스톡 에어졸<br /><span
                  class="sub"
                  >혁신을 넘어, 감동을 선사하는 프리미엄 케어</span
                >
              </h2>
            </div>
            <div class="story-part">
              <h4 class="part-title">핵심 약속</h4>
              <h3 class="part-main-text">
                보이지 않는 위협으로부터 당신의 가장 소중한 공간을 완벽하게
                지켜낼 단 하나의 약속. 아스톡은 단순한 제품을 넘어, 비교할 수
                없는 강력함과 절대적인 안전함으로 당신의 일상에 전에 없던 평온과
                감동을 선사하는 명품 솔루션입니다.
              </h3>
            </div>
            <div class="story-part">
              <h4 class="part-title">구체적인 증거</h4>
              <ul class="product-features">
                <li>
                  <span class="feature-title"
                    >⚡️ <strong>압도적인 스피드:</strong></span
                  >
                  <p>
                    단10초, 유해해충 99.9%를 완벽하게 박멸하는 경이로운 기술력.
                  </p>
                </li>
                <li>
                  <span class="feature-title"
                    >🌿 <strong>절대적인 효과성:</strong></span
                  >
                  <p>
                    특히, 보이지 않는 곳을 분사하여 숨어있는 바퀴벌레까지
                    잡아냅니다.
                  </p>
                </li>
                <li>
                  <span class="feature-title"
                    >🌌 <strong>경계 없는 활용성:</strong></span
                  >
                  <p>
                    당신의 손길이 닿는 해충이 있는 모든 곳, 식당, 집, 사무실을
                    넘어 그 어떤 공간도 해충으로부터 즉시 프리미엄 청정구역으로
                    탈바꿈시킵니다.
                  </p>
                </li>
                <li>
                  <span class="feature-title"
                    >🌬️ <strong>감각적인 마무리:</strong></span
                  >
                  <p>
                    불쾌한 바퀴벌레로 발생하는 실패비용의 고민을 해결하고,
                    공간의 품격을 높입니다.
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div class="product-buttons">
            <a href="#cta" class="btn btn-primary">구매 문의하기</a>
            <a href="#gallery" class="btn btn-secondary-outline"
              >더 많은 이미지 보기</a
            >
          </div>
        </div>
      </div>
    </section>

    <!-- 6. Construction Cases Section -->
    <section id="cases" class="cases-section bg-light animated-section">
      <div class="container">
        <SectionHeader subtitle="Construction Cases" title="시공사례" />
        <p class="section-description">
          아스톡이 함께한 다양한 현장의 시공사례를 만나보세요. 신뢰할 수 있는
          방역 솔루션으로 완성된 청정 공간을 확인하실 수 있습니다.
        </p>
        <div class="cases-grid">
          <div
            class="case-card"
            v-for="item in constructionCases"
            :key="item.title"
          >
            <div class="case-image">
              <img :src="item.image" :alt="item.title" />
            </div>
            <div class="case-body">
              <span class="case-tag">{{ item.tag }}</span>
              <h3>{{ item.title }}</h3>
              <p>{{ item.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 7. CTA Section -->
    <section id="cta" class="cta-section">
      <div class="container">
        <h2>✨ 망설이지 마세요! 지금 바로 특별한 상담을 신청하세요! ✨</h2>
        <p>
          당신의 공간을 위한 맞춤 솔루션! 전문가가 친절하게 모든 궁금증을 해결해
          드립니다.<br />
          <span class="precautions-info">
            (안전한 사용을 위해 사람이나 반려동물에게 직접 분사하지 마시고, 사용
            후 환기시켜 주세요.)
          </span>
        </p>
        <div class="cta-buttons">
          <a href="#" class="btn btn-primary">상담 신청하기</a>
          <a href="#" class="btn btn-secondary">카탈로그 다운로드</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import SectionHeader from "@/components/SectionHeader.vue";

export default {
  name: "HomeView",
  components: { SectionHeader },
  data() {
    return {
      constructionCases: [
        {
          title: "대형 오피스 빌딩 방역",
          tag: "오피스",
          desc: "연면적 15,000㎡ 규모의 오피스 빌딩 전 층 방역 시공. 근무 환경 개선과 유해해충 99.9% 제거를 완료했습니다.",
          image: require("@/assets/images/office-building.jpg")
        },
        {
          title: "프리미엄 아파트 단지",
          tag: "주거",
          desc: "500세대 규모 아파트 단지 공용부 및 세대 내 방역. 아이와 반려동물이 안심할 수 있는 청정 주거 공간을 완성했습니다.",
          image: require("@/assets/images/2-DOKVQmAK.jpg")
        },
        {
          title: "물류센터 위생 관리",
          tag: "물류",
          desc: "대규모 물류센터의 정기 방역 및 위생 관리 시공. 보관 물품의 위생 안전성을 확보했습니다.",
          image: require("@/assets/images/3-DE4RbGuR.jpg")
        },
        {
          title: "요식업 매장 방역",
          tag: "요식업",
          desc: "다수 프랜차이즈 매장의 주방 및 홀 방역 시공. 고객이 신뢰할 수 있는 위생 환경을 조성했습니다.",
          image: require("@/assets/images/4-CNzeZswI.jpg")
        },
        {
          title: "교육시설 청정 케어",
          tag: "교육",
          desc: "학교 및 학원 시설의 교실·공용공간 방역. 학생들이 안전하게 생활할 수 있는 환경을 제공했습니다.",
          image: require("@/assets/images/5-CyyYTxGg.jpg")
        },
        {
          title: "의료·요양 시설 방역",
          tag: "의료",
          desc: "요양병원 및 의료시설의 감염 예방 방역 시공. 면역이 취약한 환자를 위한 안전 성분 솔루션을 적용했습니다.",
          image: require("@/assets/images/medical-facility.jpg")
        }
      ]
    };
  },
  mounted() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            // 한 번 나타난 후에는 더 이상 관찰할 필요가 없으므로 관찰을 중지합니다.
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    this.$el
      .querySelectorAll(".animated-section")
      .forEach((el) => observer.observe(el));
  }
};
</script>

<style scoped>
/* Hero Section */
.hero-section {
  height: calc(100vh - var(--header-height));
  display: flex;
  align-items: center;
  text-align: center;
  color: white;
  position: relative;
}
.hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
    url("~@/assets/images/ujeans-earth.jpg") no-repeat center center/cover;
  /* 배경 이미지를 ujeans-earth.jpg로 변경하고, Webpack이 @ 별칭을 인식하도록 ~ 추가 */
  z-index: -1;
}
.hero-content {
  position: relative;
  z-index: 1;
  animation: fadeIn 1s ease-in-out;
}
.hero-subtitle {
  display: block;
  font-weight: 700;
  letter-spacing: 2px;
  margin-bottom: 1rem;
  color: var(--primary-red);
}
.hero-content h1 {
  font-size: 3.8rem;
  font-weight: 900;
  margin-bottom: 1.5rem;
}
.hero-content p {
  font-size: 1.25rem;
  opacity: 0.9;
  margin-bottom: 3rem;
}
.scroll-indicator {
  position: absolute;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  font-weight: 700;
  letter-spacing: 2px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  opacity: 0.8;
}
.arrow-down {
  width: 2px;
  height: 30px;
  background: white;
  position: relative;
  animation: scroll-down 2s infinite;
}
@keyframes scroll-down {
  0% {
    transform: translateY(-10px);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translateY(10px);
    opacity: 0;
  }
}

/* Features Section */
.features-section {
  padding: 0; /* 섹션 자체의 상하 여백을 완전히 제거합니다. */
  background: var(--bg-white);
  border-bottom: 1px solid var(--border-color);
}
.features-section .container {
  display: flex;
  justify-content: space-around; /* 상단 여백을 제거하여 Hero 섹션 바로 아래에 붙도록 수정 */
  padding: 2rem 0; /* 컨테이너 내부에 상하 여백을 주어 콘텐츠를 보기 좋게 합니다. */
  text-align: center;
}
.feature-item .value {
  font-size: 2.5rem;
  font-weight: 900;
  color: var(--primary-red);
}
.feature-item .label {
  font-weight: 700;
  color: var(--text-light);
}

/* Values Section */
.values-section {
  padding: 2rem 0 4rem; /* 상단 여백을 2rem으로 줄여 간격을 좁힙니다. */
}
.section-description {
  text-align: center;
  max-width: 600px;
  margin: -3rem auto 4rem;
  color: var(--text-light);
}
.values-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
}
.value-card {
  background: white;
  padding: 2.5rem;
  border-radius: 12px;
  text-align: center;
  border: 1px solid var(--border-color);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.value-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
}
.value-card .icon {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}
.value-card h3 {
  font-size: 1.5rem;
  color: var(--primary-blue);
  margin-bottom: 1rem;
}

/* Product Section */
.product-section {
  padding: 6rem 0;
}
.product-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
}
.product-image img {
  width: 100%;
  border-radius: 10px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}
.product-info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.product-info .section-subtitle {
  color: var(--primary-red);
  font-weight: 700;
}
.product-info h2 {
  font-size: 2.5rem;
  font-weight: 900;
  color: var(--primary-blue);
  margin-bottom: 0.5rem;
}
.product-info h2 .sub {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-sub);
  display: block;
}
.product-info .description {
  margin: 1.5rem 0;
  font-size: 1.1rem;
}
.product-features {
  list-style: none;
  padding: 0;
  margin: 2rem 0;
}
.product-features li {
  padding-bottom: 1.5rem;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid var(--border-color);
  line-height: 1.6;
}
.product-features li:last-child {
  border-bottom: none;
  margin-bottom: 0;
}
.feature-title {
  display: block;
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 0.75rem;
}
.product-features p {
  margin: 0;
  color: var(--text-light);
}
.product-buttons .btn {
  margin-right: 1rem;
}
.btn-secondary-outline {
  background: transparent;
  border: 2px solid var(--primary-blue);
  color: var(--primary-blue);
  transition: all 0.3s ease;
}
.product-story {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.story-part {
  margin-bottom: 0; /* 각 파트의 하단 여백을 제거하여 flexbox 정렬이 잘 동작하도록 합니다. */
}
.part-title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-sub);
  border-bottom: 2px solid var(--border-color);
  padding-bottom: 0.5rem;
  margin-bottom: 1.5rem;
}
.part-main-text {
  font-size: 1.5rem; /* 폰트 크기를 키워 주목도를 높입니다. */
  font-weight: 700; /* 폰트 두께를 늘려 강조 효과를 줍니다. */
  color: var(--primary-blue); /* '최상의 가치' 제목과 색상을 통일합니다. */
  line-height: 1.7;
}

/* Gallery Section */
.gallery-section {
  padding: 2rem 0 6rem; /* 상단 여백을 줄여서 이전 섹션과의 간격을 좁힙니다. */
}
.gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1rem;
}
.gallery-item {
  aspect-ratio: 1 / 4;
  overflow: hidden;
  background: #fff;
  border-radius: 8px;
}
.gallery-item img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: transform 0.4s ease, filter 0.4s ease;
}
.gallery-item:hover img {
  transform: scale(1.05);
  filter: brightness(1.1);
}

/* Construction Cases Section */
.cases-section {
  padding: 2rem 0 6rem;
}
.cases-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}
.case-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid var(--border-color);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
}
.case-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
}
.case-image {
  aspect-ratio: 4 / 3;
  overflow: hidden;
  background: #fff;
}
.case-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}
.case-card:hover .case-image img {
  transform: scale(1.05);
}
.case-body {
  padding: 1.75rem;
}
.case-tag {
  display: inline-block;
  background: var(--primary-red);
  color: white;
  font-size: 0.8rem;
  font-weight: 700;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  margin-bottom: 1rem;
}
.case-body h3 {
  font-size: 1.35rem;
  color: var(--primary-blue);
  margin-bottom: 0.75rem;
}
.case-body p {
  color: var(--text-light);
  line-height: 1.6;
  margin: 0;
}

/* CTA Section */
.cta-section {
  padding: 8rem 0;
  text-align: center;
  background: var(--primary-blue) url("~@/assets/images/ujeans-earth.jpg")
    no-repeat center center/cover;
  background-blend-mode: multiply;
  color: white;
}
.cta-section h2 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}
.cta-section p {
  margin-bottom: 2rem;
  opacity: 0.9;
  line-height: 1.7;
}
.precautions-info {
  display: block;
  margin-top: 1rem;
  font-size: 0.9rem;
  opacity: 0.8;
}
.cta-buttons .btn {
  margin: 0 0.5rem;
}
.cta-phone {
  margin-top: 2rem;
  font-size: 2.2rem;
  font-weight: 900;
  color: #ffffff;
  letter-spacing: 2px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.4);
  text-align: center;
}

/* --- Animation --- */
.animated-section {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}
.animated-section.visible {
  opacity: 1;
  transform: translateY(0);
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .hero-content h1 {
    font-size: 2.5rem;
  }
  .features-section .container {
    flex-direction: column;
    gap: 2rem;
  }
  .product-grid {
    grid-template-columns: 1fr;
    text-align: center;
  }
  .gallery-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .cases-grid {
    grid-template-columns: 1fr;
  }
}
</style>
